import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, TablePagination, TableFooter } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import JobsDataTableRow from './JobsDataTableRow';
import {Job } from '../JobTypes';

interface DataTableProps {
  data: Array<Job>
  handlePageChange: any
  currentPage: number
  pageSize: number
  count: number
  loading: boolean
}

const JobsDataTable = ({data, handlePageChange, currentPage, pageSize, count, loading}:DataTableProps) => {
  const classes = useStyles();

  let tableRows:any = [];
  if(loading) {
    for(let i = data.length; i < pageSize; i++) {
      tableRows.push(<JobsDataTableRow key={`skeleton-${i}`} skeleton />);
    }
  }
  else if(data) {
    tableRows = data.map( (row) => (<JobsDataTableRow key={row.id} data={row} />));
    if( data.length < pageSize ) {
      for(let i = data.length; i < pageSize; i++) {
        tableRows.push(<JobsDataTableRow key={`blank-${i}`} />);
      }
    }
  }

  const buttonProps = loading ? {disabled: true} : undefined;

  return (
    <TableContainer className={classes.root}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell size="small" align="center">Request #</TableCell>
            <TableCell size="small" style={{width:"99%"}}>Job Information</TableCell>
            <TableCell size="small">Received</TableCell>
            <TableCell size="small">Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          { tableRows }
        </TableBody>
        <TableFooter>
          <TablePagination
            count={count}
            onChangePage={handlePageChange}
            page={currentPage}
            rowsPerPage={pageSize}
            rowsPerPageOptions={[]}
            nextIconButtonProps={buttonProps}
            backIconButtonProps={buttonProps}
          />
        </TableFooter>
      </Table>
    </TableContainer>                
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiTableCell-head': {
      backgroundColor: theme.palette.grey[50],
      padding: theme.spacing(1.5, 2),
      whiteSpace: "nowrap",
    },
    '& .MuiTableCell-body': {
      padding: theme.spacing(3, 2),
      whiteSpace: "nowrap",
      '& a': {
        fontSize: '1rem',
        textDecorationLine: 'underline',
        color: theme.palette.primary.light,
      },
    },
    '& .MuiChip-root': {
      borderRadius: '16px',
      fontWeight: 500,
      lineHeight: 1.5,
    },
    '& .Pending': {
      '& .MuiTableCell-body': {
        background: 'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #2196F3',
      },
      '& .MuiChip-root': {
        background: theme.palette.info.main,
        color: '#FFFFFF',
      },
    },
    '& .urgent': {
      '& .MuiTableCell-body': {
        background: 'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #F0533E',
      },
      '& .MuiChip-root': {
        background: '#E31B0C',
        color: '#FFFFFF',
      },
    },
    '& .InProgress': {
      '& .MuiTableCell-body': {
        background: 'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #FF9800',
      },
      '& .MuiChip-root': {
        background: '#FF9800',
        color: '#FFFFFF',
      },
    },
    '& .Complete': {
      '& .MuiTableCell-body': {
        background: 'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #4CAF50',
      },
      '& .MuiChip-root': {
        background: theme.palette.success.main,
        color: '#FFFFFF',
      },
    },
  },
}));

export default JobsDataTable;